"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBar = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var ProjectSelector_1 = require("components/ProjectSelector");
var Types = require("types");
var OrderListActions = require("@caddigital/sok-reducers/lib/actions/order/list");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var Icon_1 = require("components/Icon");
var constants_1 = require("utils/constants");
var mapStateToProps = function (state) {
    return {
        searchString: state.order.list.searchString
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    setSeachString: function (searchString) {
        return dispatch(OrderListActions.setSearchString(searchString));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.withState)('tempValue', 'setTempValue', null), recompose_1.pure);
var clearSearchCross = function (props) {
    return (React.createElement("span", { className: 'file-list-search-box-right' }, props.searchString !== '' && (React.createElement(Icon_1.Icon, { onClick: function () { return props.setSeachString(''); }, className: "fa-times" }))));
};
var timeout = null;
exports.SearchBar = enhance(function (props) { return (React.createElement(sok_ui_1.Grid.Row, { className: 'sok-search-bar-content' },
    React.createElement(sok_ui_1.Grid.Column, { extraSmall: 12 },
        React.createElement(ProjectSelector_1.ProjectSelector, { navigateToProject: props.navigateToProject }),
        React.createElement("div", { className: 'search-area' },
            React.createElement(sok_ui_1.TextInput, { value: props.tempValue === null ? props.searchString : props.tempValue, placeholder: (0, translation_1.getLocalization)('userfront/automaticorders/search'), onChange: function (e) {
                    var value = e.target.value;
                    props.setTempValue(value);
                    if (timeout) {
                        clearTimeout(timeout);
                    }
                    timeout = setTimeout(function () {
                        props.setSeachString(value);
                        props.setTempValue(null);
                    }, constants_1.SEARCH_TIMEOUT);
                }, icon: React.createElement(Icon_1.Icon, { key: "icon", className: 'fa-search' }), iconRight: clearSearchCross(props) }))))); });
